'use client';

import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { intervalToDuration, isBefore } from 'date-fns';

import CountdownCard from './CountdownCard';
import useIsMounted from './hooks/useIsMounted';

interface CurrentPrevious {
  current: Countdown;
  previous: Countdown | null;
}

interface Countdown {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

// const useCountdown = (endDate: DateTime): CurrentPrevious => {
//   const initial = getTimeLeft(endDate)
//   const [{ current, previous }, setCountdown] = useState<CurrentPrevious>({ current: initial, previous: null })

//   useEffect(() => {
//     const timer = window.setInterval(() => {
//       setCountdown(({ current }) => {
//         return {
//           previous: current,
//           current: getTimeLeft(endDate)
//         }
//       })
//     }, 1000)
//     return () => clearInterval(timer)
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   return { previous, current }
// }

const Countdown = ({
  endDate,
  transformOrigin,
  scale,
  height,
  cardColor,
  numberColor,
  textColor,
  hideHeader,
}: {
  endDate?: Date;
  transformOrigin?: string;
  scale?: string;
  height?: string;
  cardColor?: string;
  numberColor?: string;
  textColor?: string;
  hideHeader?: boolean;
}): ReactElement => {
  const isMounted = useIsMounted();
  // const defaultTime = useMemo(() => DateTime.local().plus({ days: 3, hours: 0, minutes: 0, seconds: 3 }), [])

  const [refresh, setRefresh] = useState<boolean>(false);
  const [refreshUsed, setRefreshUsed] = useState<boolean>(false);
  const [timer, setTimer] = useState<number | null>(null);
  // const initialDate = DateTime.fromISO(endDate);
  // const { current, previous } = useCountdown(initialDate);
  //   initialDate?.isValid
  //     ? initialDate
  //     : defaultTime
  // )

  const getTimeLeft = (endDateValue: Date): Countdown => {
    const now = new Date();

    if (isBefore(endDateValue, now)) {
      if (timer) {
        clearInterval(timer);
      }
      if (!refreshUsed && !refresh) {
        setRefresh(true);
      }
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const duration = intervalToDuration({ start: now, end: endDateValue });

    return {
      days: duration.days || 0,
      hours: duration.hours || 0,
      minutes: duration.minutes || 0,
      seconds: duration.seconds || 0,
    };
  };

  const initial = endDate ? getTimeLeft(endDate) : { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const [{ current, previous }, setCountdown] = useState<CurrentPrevious>({
    current: initial,
    previous: null,
  });

  useEffect(() => {
    if (!refresh || refreshUsed) {
      return;
    }
    setRefreshUsed(true);
    window.location.reload();
  }, [refresh, refreshUsed]);

  useEffect(() => {
    if (!endDate) {
      return;
    }
    const timer = window.setInterval(() => {
      setCountdown(({ current }) => {
        return {
          previous: current,
          current: getTimeLeft(endDate),
        };
      });
    }, 1000);
    setTimer(timer);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate]);

  // return { previous, current }

  if (!isMounted || !endDate) return <></>;

  return (
    <div
      style={{
        transform: `scale(${scale || '0.4'})`,
        transformOrigin: `${transformOrigin || 'top left'}`,
        // width: `${current.days > 0 ? 320 : 240}px`,
        height: `${height || '200'}px`,
      }}
    >
      {!hideHeader && (
        <div
          className="text-xs lg:text-2xl text-left text-theme_grayishBlue lg:font-bold tracking-widest pt-3.5 lg:pt-7 mb-4"
          style={{ width: '250%', color: textColor }}
        >
          İNDİRİMİN BİTMESİNE KALAN SÜRE:
        </div>
      )}
      <div className="flex space-x-2 lg:space-x-4 items-center">
        {current.days > 0 && (
          <CountdownCard
            id={`days${current.days}-${previous?.days}`}
            label="GÜN"
            key={`days${current.days}-${previous?.days}`}
            current={current.days}
            previous={previous?.days}
            cardColor={cardColor}
            numberColor={numberColor}
            textColor={textColor}
          />
        )}
        <CountdownCard
          id={`hours${current.hours}-${previous?.hours}`}
          label="SAAT"
          key={`hours${current.hours}-${previous?.hours}`}
          current={current.hours}
          previous={previous?.hours}
          cardColor={cardColor}
          numberColor={numberColor}
          textColor={textColor}
        />
        <CountdownCard
          id={`minutes${current.minutes}-${previous?.minutes}`}
          label="DAKİKA"
          key={`minutes${current.minutes}-${previous?.minutes}`}
          current={current.minutes}
          previous={previous?.minutes}
          cardColor={cardColor}
          numberColor={numberColor}
          textColor={textColor}
        />
        <CountdownCard
          id={`seconds${current.seconds}-${previous?.seconds}`}
          label="SANİYE"
          key={`seconds${current.seconds}-${previous?.seconds}`}
          current={current.seconds}
          previous={previous?.seconds}
          cardColor={cardColor}
          numberColor={numberColor}
          textColor={textColor}
        />
      </div>
    </div>
  );
};

export default Countdown;
